import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingBag, ArrowUpRight } from 'lucide-react';
import { Button } from './ui/button';
import { imageUrl, euro, collectionLabels } from '../lib/catalog';

export const ProductCard = ({ product, onAdd }) => {
  const location = useLocation();
  const state = location.pathname === '/webshop' ? { catalogReturn: location.pathname + location.search } : undefined;
  return (
  <article className="premium-product-card group" data-testid={`webshop-product-${product.id}`}>
    <Link to={`/product/${product.id}`} state={state} aria-label={product.name} data-testid={`webshop-image-link-${product.id}`}>
      <div className="premium-product-image"><img src={imageUrl(product.image)} alt={product.name} loading="lazy" data-testid={`webshop-image-${product.id}`} /></div>
    </Link>
    <div className="premium-product-body">
      <p className="premium-product-meta" data-testid={`webshop-category-${product.id}`}>{collectionLabels[product.collection]} · MAXLIGHT</p>
      <Link to={`/product/${product.id}`} state={state} aria-label={product.name} data-testid={`webshop-name-link-${product.id}`}>
        <h2 className="premium-product-family break-words" data-testid={`webshop-name-${product.id}`}>{product.family || product.name}</h2>
      </Link>
      <p className="premium-product-meta" data-testid={`webshop-sku-${product.id}`}>Šifra: {product.sku}</p>
      <p className="premium-product-description line-clamp-2" data-testid={`webshop-description-${product.id}`}>{product.description}</p>
      <div className="premium-product-bottom">
        <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1 mb-4">
          <p className="premium-product-price" data-testid={`webshop-price-${product.id}`}>{euro(product.price)}</p><p className="text-[10px] text-gray-500" data-testid={`webshop-vat-${product.id}`}>s PDV-om</p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" className="flex-1 rounded h-11 text-xs" asChild><Link to={`/product/${product.id}`} state={state} data-testid={`webshop-details-link-${product.id}`}>Detalji <ArrowUpRight size={15} /></Link></Button>
          <Button onClick={() => onAdd(product)} disabled={!product.inStock} className="flex-1 rounded h-11 text-xs" data-testid={`webshop-add-${product.id}`}><ShoppingBag size={15} aria-hidden="true" />{product.inStock ? 'Dodaj' : 'Nedostupno'}</Button>
        </div>
      </div>
    </div>
  </article>
  );
};